import React from 'react';
import PropTypes from 'prop-types';
import { Router, Route, hashHistory } from 'react-router';
import { Provider } from 'react-redux';

import RouteNotFound from '../components/RouteNotFound/RouteNotFound';
import PermissionDeniedPage from '../components/error/PermissionDeniedPage';
import EmptyQuestionSetPage from '../components/error/EmptyQuestionSetPage';
import ForbiddenItemsPage from '../components/error/ForbiddenItemsPage';
import ResponseNotProcessedPage from '../components/error/ResponseNotProcessedPage';
import InvalidTabToken from '../components/error/InvalidTabTokenPage';
import EmptyContentBlockPage from '../components/error/EmptyContentBlockPage';

import viewReadyTracker from '../services/ViewReadyTracker';

function onEnter(nextState) {
    viewReadyTracker.logError();
    console.log('Showing error route: ', nextState);
}
const routes = [
    <Route path="/error/403" component={PermissionDeniedPage} onEnter={onEnter} key="error-1" />,
    <Route path="/error/invalid-tab-token" component={InvalidTabToken} onEnter={onEnter} key="error-2" />,
    <Route path="/error/empty-question-set" component={EmptyQuestionSetPage} onEnter={onEnter} key="error-3" />,
    <Route path="/error/forbidden-items" component={ForbiddenItemsPage} onEnter={onEnter} key="error-4" />,
    <Route path="/error/response-not-processed" component={ResponseNotProcessedPage} onEnter={onEnter} key="error-5" />,
    <Route path="/error/empty-section" component={EmptyContentBlockPage} onEnter={onEnter} key="error-7" />,
    <Route path="*" component={RouteNotFound} onEnter={onEnter} key="error-6" />,
];

class ErrorRouting extends React.Component {
    static propTypes = {
        store: PropTypes.object.isRequired,
    };

    render() {
        return (
            <Provider store={this.props.store}>
                <Router history={hashHistory}>
                    {routes}
                </Router>
            </Provider>
        );
    }
}

export default ErrorRouting;
